module.exports = __webpack_public_path__ + "static/media/PH3800__007_Boss-30sec.5a4ce6e1.mp3";